import AnnotationsTable from './AnnotationsTable';
import AnnotationsColumns from './AnnotationsColumns';
import AnnotationsRows from './AnnotationsRows';

export default AnnotationsTable;
export {
  AnnotationsColumns,
  AnnotationsRows
};
